type InnerValue = string | boolean | number;
type ObjectWithInnerArrays = {
  [key: string]: InnerValue | string[] | ObjectWithInnerArrays;
};
type ObjectWithoutInnerArrays = {
  [key: string]: InnerValue | ObjectWithInnerArrays;
};

const convertInnerArraysToStrings = <T extends ObjectWithInnerArrays>(props: T) => {
  const newObject: ObjectWithoutInnerArrays= {};

  Object.entries(props).forEach(([key, value]) => {
    if (Array.isArray(value)) {
      newObject[key] = value.join(', ');
    }
    else if (value && typeof value === 'object') {
      newObject[key] = convertInnerArraysToStrings(value);
    }
    else {
      newObject[key] = value;
    }
  });

  return newObject;
};

export const freshchatSetProperty = <T extends ObjectWithoutInnerArrays>(key: string, value: T) => {
  const fcWidget = window?.fcWidget;

  if (fcWidget) {
    return fcWidget[key]?.setProperties(convertInnerArraysToStrings(value));
  }

  console.warn('The freshchatSetProperty function was called when fcWidget was undefined.');
};
